export const SIDEBAR_WIDTH = 233;
export const USER_MENU_WIDTH = 270;
export const NAV_HEIGHT = 60;
export const SHOW_UPGRADE_BUTTON = ['pioneer', 'trial_end', 'track_n_dispatch', 'team', 'starter'];

export const BANNER_HEIGHT = 40;
